// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"29":"55585e47","89":"68b0e37f","154":"38dfad91","192":"6bd909b3","374":"51a0cd15","388":"a3b5c447","494":"31fee82f","682":"801dff0e","699":"a07e9ad6","748":"ef3709c5","814":"19b2c759","905":"53c2b112","927":"c27fb4cf","955":"6eef82e3"}[chunkId] + ".js";
};